import * as React from 'react';
import { useState } from 'react';
import ThirdPartyValue from '../../../models/thirdPartyValues/ThirdPartyValue';
import { apiPut } from '../../../services/api';
import EditModal from '../../../components/admin/thirdPartyManagement/update/EditModal';
import LoadingModal from '../../../components/common/LoadingModal';
import ErrorModal from '../../../components/common/ErrorModal';
import DropdownOption from '../../../lib/bootstrap-ui/Dropdown/DropdownOption';
import { getErrorMessage } from '../../../helpers/errors';

interface EditModalContainerProps {
    showModal: boolean;
    thirdPartyValue: ThirdPartyValue;
    selectedOption: DropdownOption;
    onClose(): void;
}

const EditModalContainer: React.FC<EditModalContainerProps> = ({
    showModal,
    thirdPartyValue,
    selectedOption,
    onClose
}) => {
    const [updatingValues, setUpdatingValues] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>();

    const handleEditRequested = async (updatedValue: string) => {
        setUpdatingValues(true);
        try {
            const updatedThirdPartyValue: ThirdPartyValue = {
                id: thirdPartyValue.id,
                value: updatedValue
            };
            await apiPut(
                `${selectedOption.value}/${thirdPartyValue.id}`,
                updatedThirdPartyValue
            );
            setUpdatingValues(false);
            onClose();
        } catch (e) {
            setUpdatingValues(false);
            setErrorMessage(getErrorMessage(e));
        }
    };

    const showLoadingModal = showModal && updatingValues;
    const showEditModal = showModal && !updatingValues && !errorMessage;
    const showErrorModal = showModal && !!errorMessage;

    return (
        <>
            <LoadingModal
                showModal={showLoadingModal}
                loadingText="updating..."
            />
            <EditModal
                showModal={showEditModal}
                selectedOption={selectedOption}
                thirdPartyValue={thirdPartyValue}
                onEditRequested={handleEditRequested}
                onClose={onClose}
            />
            <ErrorModal
                showModal={showErrorModal}
                header="Error"
                errorText={errorMessage}
                onClose={onClose}
            />
        </>
    );
};

export default EditModalContainer;
